export const ResizeIcon = (props: React.SVGAttributes<SVGSVGElement>) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <mask
      id='mask0_157_189'
      mask-type='alpha'
      maskUnits='userSpaceOnUse'
      x='5'
      y='5'
      width='14'
      height='14'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.625 6.00024C13.625 5.65507 13.9048 5.37524 14.25 5.37524H17.9C17.9175 5.37524 17.9348 5.37586 17.952 5.37708C18.1275 5.36364 18.3077 5.42404 18.4419 5.5583C18.5762 5.69256 18.6366 5.87271 18.6232 6.04826C18.6244 6.06543 18.625 6.08277 18.625 6.10024V9.75024C18.625 10.0954 18.3452 10.3752 18 10.3752C17.6548 10.3752 17.375 10.0954 17.375 9.75024V7.50913L13.9419 10.9422C13.6979 11.1863 13.3021 11.1863 13.0581 10.9422C12.814 10.6981 12.814 10.3024 13.0581 10.0583L16.4911 6.62524H14.25C13.9048 6.62524 13.625 6.34542 13.625 6.00024ZM6.1 18.6252C6.08252 18.6252 6.06518 18.6246 6.048 18.6234C5.87245 18.6368 5.69231 18.5764 5.55806 18.4422C5.4238 18.3079 5.36339 18.1278 5.37684 17.9522C5.37562 17.9351 5.375 17.9177 5.375 17.9002V15.0002V14.2502C5.375 13.9051 5.65482 13.6252 6 13.6252C6.34518 13.6252 6.625 13.9051 6.625 14.2502V15.0002V16.4914L10.0581 13.0583C10.3021 12.8142 10.6979 12.8142 10.9419 13.0583C11.186 13.3024 11.186 13.6981 10.9419 13.9422L7.50888 17.3752L9.75 17.3752C10.0952 17.3752 10.375 17.6551 10.375 18.0002C10.375 18.3454 10.0952 18.6252 9.75 18.6252H9.00156L6.1 18.6252Z'
        fill='black'
      />
    </mask>
    <g mask='url(#mask0_157_189)'>
      <rect x='3' y='3' width='18' height='18' fill='#808080' />
    </g>
  </svg>
)
